import { Button } from "antd";
import React from "react";
import styled from "styled-components";

const ButtonWraper = styled(Button)`
  min-width: ${({ width }) => width || 107}px;
  min-height: ${({ height }) => height || 48}px;
  border-radius: ${({ radius }) => radius || 14}px;
  color: ${({ color }) => color || "#667085"};
  font-weight: ${({ fontweight }) => fontweight || 600};
  padding-left: ${({ paddingLeft }) => paddingLeft || 24}px;
  padding-right: ${({ paddingRight }) => paddingRight || 24}px;
  padding-top: ${({ paddingTop }) => paddingTop || 12}px;
  padding-bottom: ${({ paddingBottom }) => paddingBottom || 12}px;
  border: none;
  font-size: 16px;
  line-height: 24px;
  max-width: 100%;
  &.black {
    color: #ffffff;
    background: #000000;
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
    &:hover,
    &:focus,
    &:active {
      color: #ffffff;
      background: #000000;
    }
  }
  &.black2 {
    color: #000000;
    background: #ffffff;
    border: 1px solid #000;
  }
  &.black2[disabled] {
    opacity: 0.5;
    pointer-events: none;
    curspor: not-allowed;
  }
  &.white {
    box-shadow: none;
    background: rgba(255, 255, 255, 0.75);
    color: #667085;
  }
  &.primary {
    background: #000;
    font-size: 16px;
    line-height: 19px;
    color: rgba(255, 255, 255, 0.5);
    opacity: 0.5;
    border-radius: 15px;
  }
  &.primary2 {
    background: #000;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #ffffff;
    border-radius: 15px;
    &[disabled] {
      opacity: 0.5;
      pointer-events: none;
    }
  }
`;

export const FormButton2 = ({ children, ...props }) => {
  return <ButtonWraper {...props}>{children}</ButtonWraper>;
};

export default FormButton2;
